function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "High-Fi-",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "REJ2--krok1-",
  transform: "translate(-25.000000, -560.000000)"
}, /*#__PURE__*/React.createElement("rect", {
  fill: "#FFFFFF",
  x: 0,
  y: 0,
  width: 414,
  height: 896
}), /*#__PURE__*/React.createElement("g", {
  id: "Row",
  transform: "translate(25.000000, 540.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Icon/Number",
  transform: "translate(0.000000, 20.000000)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Safespace",
  x: 0,
  y: 0,
  width: 24,
  height: 24
}), /*#__PURE__*/React.createElement("g", {
  id: 2,
  transform: "translate(0.000000, 1.200000)",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  fill: "#48A9A1",
  opacity: 0.2,
  x: 5.508,
  y: 4.8,
  width: 10.32,
  height: 12.84
}), /*#__PURE__*/React.createElement("path", {
  d: "M22.692,0.143992946 L3.792,0.143992946 C3.54678557,0.143992946 3.34782827,0.342785571 3.34782827,0.588 L3.34782827,18.648 C3.3446529,18.7667506 3.39035567,18.8816389 3.47435837,18.9656416 C3.55836108,19.0496443 3.6732494,19.0953471 3.792,19.0921717 L22.692,19.0921717 C22.8118213,19.0952396 22.927862,19.0498953 23.0137418,18.9662754 C23.0996217,18.8826555 23.1480438,18.7678651 23.148,18.648 L23.148,0.648 C23.1616584,0.518985148 23.1197159,0.390260238 23.0326744,0.294056483 C22.9456329,0.197852727 22.8217338,0.143279028 22.692,0.143992946 Z M14.4,16.548 L7.38,16.548 L7.38,14.892 L10.788,11.292 C11.3893534,10.7465591 11.7694188,9.99923935 11.856,9.192 C11.8748258,8.84650267 11.7436018,8.50969437 11.496,8.268 C11.204033,8.04681621 10.8412246,7.94010786 10.476,7.968 C9.48834241,8.00770185 8.53702426,8.35134981 7.752,8.952 L7.032,7.32 C7.49544573,6.9323065 8.03506602,6.64614423 8.616,6.48 C9.24788891,6.27525221 9.90777017,6.16999507 10.572,6.168 C11.4837585,6.1182911 12.3840544,6.39007855 13.116,6.936 C13.7356754,7.43817268 14.0825056,8.20297779 14.052,9 C14.0580487,9.57204748 13.9349954,10.1380925 13.692,10.656 C13.3703214,11.2680027 12.9665933,11.8332221 12.492,12.336 L10.176,14.736 L14.4,14.736 L14.4,16.548 Z",
  id: "Shape",
  fill: "#48A9A1"
}), /*#__PURE__*/React.createElement("path", {
  d: "M20.4,21.456 L1.452,21.456 C1.12062915,21.456 0.852,21.1873708 0.852,20.856 L0.852,2.856 C0.852,2.52462915 1.12062915,2.256 1.452,2.256 L20.4,2.256 C20.7313708,2.256 21,2.52462915 21,2.856 L21,20.856 C21,21.1873708 20.7313708,21.456 20.4,21.456 Z M2.1,20.256 L19.752,20.256 L19.752,3.456 L2.052,3.456 L2.1,20.256 Z",
  id: "Shape",
  fill: "#555150"
}))))));

var SvgSecond = function SvgSecond(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSecond, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Second.3f22c874.svg";
export { ForwardRef as ReactComponent };